<template>
  <div class="p-4">
     <vue-headful title="Options File Validator" />
     <div class="kpt-upload-files-grid" v-if="!isValidationDataDisplayed">
       <b-loading :is-full-page="false" v-model="isSubmitting" :can-cancel="false"></b-loading>
       <b-message type="is-light" class="content">
         Kymeta options file checker is designed to validate an iDirect Evolution options file for compatibility with a Kymeta satellite terminal. The options file checker will highlight the most common error that may lead to compatibility issues. It cannot detect all issues, especially those of network routing errors or other hub-side configuration variances that may exist.
         <br/><br/>
         Release 1.0
         </b-message>
       <div>
         <b-field label="Upload Files" required>
           <b-upload v-model="filesToUpload" drag-drop expanded multiple accept=".opt" validationMessage="Please select valid files" class="upload-width-400">
             <section class="section">
               <div class="content has-text-centered">
                 <p><b-icon icon="upload" size="is-large"></b-icon></p>
                 <p>Drop your files here or click to upload (only .opt)</p>
               </div>
             </section>
           </b-upload>
         </b-field>
         <div class="tags">
             <span v-for="(file, index) in filesToUpload"
                 :key="index"
                 class="tag is-primary" >
                 {{file.name}}
                 <button class="delete is-small"
                     type="button"
                     @click="deleteFilesToUpload(index)">
                 </button>
             </span>
         </div>
       </div>
     </div>
     <b-table 
         v-if="isValidationDataDisplayed" 
         :data="validationResults" 
         class="has-horizontal-scroll" 
         ref="table" 
         detailed hoverable>
         <h6><strong>Valid Files : {{validFileNames.length}}/{{noOfFiles}}</strong></h6>
             <br/>
         <h6 v-if="validFileNames.length > 0"><strong>Valid Files :</strong> {{validFileNames.join(', ')}}</h6>
             <br v-if="validFileNames.length > 0"/>
         <b-table-column v-if="!!(validationResults.length > 0)" field="fileName" label="Files' Error(s) / Disclaimer(s)" v-slot="props" cell-class="lr-padding-remove" header-class="lr-padding-remove">
           <span><strong>Filename :</strong> {{ props.row.fileName }}</span>
         </b-table-column>
         <template slot="detail" slot-scope="props">
           <span v-if="props.row.error">
             <p><strong>{{props.row.error}}</strong></p>
           </span>
           <span v-for="(err, inxx) in props.row.errorField" :key="inxx">
             <br/>
             <p><strong>Field :</strong> {{err.field}}</p>
             <p v-if="!!err.error" style="white-space: pre-line"><strong class="has-text-danger">Error :</strong>{{err.error}}</p>
             <p v-if="!!err.disclaimer" style="white-space: pre-line"><strong class="has-text-warning">Disclaimer :</strong>{{err.disclaimer}}</p>
           </span>
         </template>
     </b-table>
     <footer class="kpt-create-navigation">
       <div class="buttons">
         <b-button type="is-primary" :disabled="!canSubmit || isSubmitting" @click="uploadFiles" :loading="isSubmitting">Validate files</b-button>
         <b-button type="is-primary" :disabled="!isValidationDataDisplayed" @click="clearForm" :loading="isSubmitting">Clear</b-button>
       </div>
     </footer>
   </div>
 </template>
<script>

export default {
  data() {
    return {
      isSubmitting: false,
      filesToUpload: null,
      isValidationDataDisplayed: false,
      validationResults: [],
      noOfFiles: 0,
      validFileNames: []
    }
  },
  methods: {
    async uploadFiles() {
      if (!this.canSubmit) return;
      this.isSubmitting = true;

      const formData = new FormData();
      this.filesToUpload.forEach(file => formData.append('files', file, file.name));
      try {
        const res = await fetch('/v2/remotes/options/validate', {
          body: formData,
          method: 'POST'
        });
        if (!res.ok) {
          const error = await res.text();
          this.$buefy.toast.open({
            duration: 5000,
            message: `Error occured: ${error}`,
            type: 'is-danger'
          });
          this.isSubmitting = false
          return;
        }
        const data = await res.json();
        this.noOfFiles = data?.totalFiles ?? 0;
        const resultData = data?.results;
        resultData?.forEach(rd => {
          this.validationResults.push({
            fileName: rd?.fileName,
            error: rd?.error,
            errorField: rd?.fields?.filter(x => !!(x.error?.length > 0) || !!(x.disclaimer?.length > 0))?.map(m => ({ field: m.field, error: m.error, disclaimer: m.disclaimer }))
          });
          // eslint-disable-next-line no-extra-boolean-cast, no-unused-expressions
          !!rd?.isValid ? this.validFileNames.push(rd?.fileName) : 'do nothing';
        })
        this.isValidationDataDisplayed = true;
      } catch (ex) {
        this.$buefy.toast.open({
          duration: 3000,
          message: `Error occured: ${ex.message}`,
          type: 'is-danger'
        });
        this.isSubmitting = false;
        // eslint-disable-next-line consistent-return
        return false;
      } finally {
        // reset display disrupts
        this.filesToUpload = null;
      }
      this.isSubmitting = false;
      // KyAnalytics client plugin, event tracker
      this.$kya.event('system', 'uploadOptionfiles', 'Optionfiles submitted', { payload: JSON.stringify(this.filesToUpload?.map(ftu => ({ fileName: ftu.name }))) });
    },
    deleteFilesToUpload(index) {
      this.filesToUpload.splice(index, 1)
    },
    close() {
      this.$router.push({ path: '/remotes' });
    },
    clearForm() {
      this.validationResults = [];
      this.isValidationDataDisplayed = false;
      this.filesToUpload = null;
      this.validFileNames = [];
    }
  },
  computed: {
    canSubmit() {
      return !!this.filesToUpload?.length;
    }
  }
}
</script>
 <style lang="scss" scoped>
 @import '../styles/_colors';
 @import '../styles/mixins';
 
 .kpt-optionfilevalidator-pane {
   height: 100%;
   display: flex;
   flex-direction: column;
 
   .kpt-context-pane-main {
     flex: 1 1 auto;
     overflow-y: auto;
   }
 }
 .result-data{
   height: 100%;
 }  
 .kpt-upload-files-grid {
     position: relative;
     gap: 12px;
 }
 .text-decoration-underline {
   text-decoration: underline;
 }
 .kpt-detail-content-page {
   .field .icon {
     position: relative;
     top: 2px;
   }
 }
 .upload-width-400 {
   width: 400px !important;
 }
 .kpt-context-pane-main, .kpt-context-pane-footer {
   padding: 1em;
 }
 .expandable {
   transition: width 0.5s;
 }
 </style>
